import React from 'react';
import styles from './LoadingSpinner.module.css';

/**
 * 统一的加载动画组件
 * @param {'small'|'medium'|'large'} size - 尺寸：small(20px) / medium(32px) / large(40px)
 * @param {string} text - 可选的加载提示文字
 * @param {boolean} fullPage - 是否占满整个视口垂直居中
 */
const LoadingSpinner = ({ size = 'medium', text, fullPage = false }) => {
  return (
    <div className={`${styles.wrapper} ${fullPage ? styles.fullPage : ''}`}>
      <div className={`${styles.spinner} ${styles[size]}`}>
        <svg viewBox="0 0 50 50" className={styles.svg}>
          <circle
            cx="25" cy="25" r="20"
            fill="none"
            strokeWidth="4"
            className={styles.track}
          />
          <circle
            cx="25" cy="25" r="20"
            fill="none"
            strokeWidth="4"
            strokeLinecap="round"
            className={styles.arc}
          />
        </svg>
      </div>
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};

export default LoadingSpinner;

